import { FORMAT, format } from 'utils/date';
import { formatSlotTime } from 'utils/format-slot-time';

interface SlotDetails {
  slotDate?: string;
  slotEndTime?: string;
  slotStartTime?: string;
}

interface SlotButtonTextProps {
  isSlotBooked?: boolean;
  showEndTime?: boolean;
  slotDetails?: SlotDetails;
  shortTime?: boolean;
}

const slotButtonTextDefaultPropSlotDetails: SlotDetails = {
  slotDate: undefined,
  slotEndTime: undefined,
  slotStartTime: undefined,
};

const SlotButtonText = ({
  isSlotBooked,
  showEndTime,
  slotDetails: { slotDate, slotEndTime, slotStartTime } = slotButtonTextDefaultPropSlotDetails,
  shortTime,
}: SlotButtonTextProps): string => {
  if (isSlotBooked && slotDate && slotStartTime) {
    if (shortTime) {
      return `${format(slotDate, FORMAT.SHORT_DAY)}, ${formatSlotTime(
        slotStartTime,
      )?.toLowerCase()}`;
    }

    return `${format(slotDate, FORMAT.SHORT_2DAY_MONTH)}, ${formatSlotTime(
      slotStartTime,
    )?.toLowerCase()}${
      showEndTime && slotEndTime ? ` - ${formatSlotTime(slotEndTime)?.toLowerCase()}` : ''
    }`;
  }

  return 'Book a slot';
};

SlotButtonText.displayName = 'SlotButtonText';

export default SlotButtonText;
